import { ReactNode } from 'react';
import { SerializedStyles, css } from '@emotion/react';
import { InvoiceSummary as InvoiceSummaryModel } from '@frontend/api-invoices';
import { useTranslation } from '@frontend/i18n';
import { SummaryItem } from '../../';

export interface InvoiceSummaryProps {
  summary?: InvoiceSummaryModel;
  loading: boolean;
  style?: SerializedStyles;
  children?: ReactNode;
}

export type SummaryCardProps = Omit<InvoiceSummaryProps, 'style'> & {
  displayDateLabel?: string;
};

export const InvoiceSummary = ({ summary, loading, style }: InvoiceSummaryProps) => {
  const { t } = useTranslation('payments');
  return (
    <div
      className='invoice-summary-card'
      css={[
        css`
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          max-width: 720px;
          flex-wrap: wrap;
        `,
        style,
      ]}
    >
      <SummaryItem
        label={t('Amount Processed')}
        amount={summary?.gross}
        loading={loading}
        infoText={t('Total amount processed by your account. Active report filters will impact the displayed data.')}
        data-trackingid='pay-portal-invoices-btn-amountprocessedhint'
      />
      <SummaryItem
        label={t('Refunds')}
        amount={summary?.refunds}
        loading={loading}
        infoText={t(
          'Total amount of refunds collected by your account. Active report filters will impact displayed data.'
        )}
        data-trackingid='pay-portal-invoices-btn-refundshint'
      />
      <SummaryItem
        label={t('Fees')}
        amount={summary?.fees}
        loading={loading}
        infoText={t('Total amount of fees charged. Active report filters will impact displayed data.')}
        data-trackingid='pay-portal-invoices-btn-feeshint'
      />
      <SummaryItem
        label={t('Net')}
        amount={summary?.net}
        loading={loading}
        infoText={t('Total amount of net revenue after fees. Active report filters will impact displayed data.')}
        data-trackingid='pay-portal-invoices-btn-nethint'
      />
    </div>
  );
};
